export class TouchPointModel {
  id?: number;
  code: string;
  description: string;
  privacyList?: TouchPointPrivacyModel[];
  ochannel_type_pid?: string;
  type?: string;
  flg_coupon_scope?: string;
  flg_coupon_action?: string;
  flg_deployable?: string;
  flg_offline?: string;
  preview_url?: string;
  code_preview?: string;
  certifier?: string;
  flg_no_default?: string;
  max_reservable_coupons?: number;
  max_usable_coupons?: number;
  max_restorable_coupons?: number;
}

export interface Touchpoint {
  active?: boolean;
  challengeOchannelsId?: number;
  code: string;
  description: string;
  flg_coupon_scope?: string;
  flg_coupon_action?: string;
  flg_deployable?: string;
  flg_offline?: string;
  id?: number;
  ochannel_type_pid?: string;
  privacyList?: TouchPointPrivacyModel[];
  templateValue?: any;
  type?: string;
  valid?: boolean;
}


export class TouchPointPrivacyModel {
  id?: number;
  row_number: number;
  flg_privacy_terminal: string;
  flg_privacy_mktg_profiling: string;
  flg_privacy_generic_comm: string;
  flg_privacy_mktg_research: string;
  flg_privacy_auth: string;
  flg_privacy_mktg_activitiy: string;
  flg_privacy_purchase_com: string;
  flg_privacy_optin: string;
  flg_newsletter: string;
  action_1_pid: number;
  action_1?: string;
  action_2_pid: number;
  action_2?: string;
  action_3_pid: number;
  action_3?: string;
  action_4_pid: number;
  action_4?: string;
  action_5_pid: number;
  action_5?: string;

}


// WEBPACK FOOTER //
// ./src/app/models/touch-point.model.ts